import CustomerList from './CustomerList.kr'
import CustomerInfo from './CustomerInfo.kr'
import UserCreateAccount from './UserCreateAccount.kr'
import UserCreateAccountSelectManager from './components/UserCreateAccountSelectManager.kr'
import CustomerInfoChangePassword from './components/CustomerInfoChangePassword.kr'
import CustomerInfoChangeInfo from './components/CustomerInfoChangeInfo.kr'
import UserGroup from './components/UserGroup.kr'

const userCommon = {
  'user.error': '오류가 발생헀습니다.',
}

export default {
  ...userCommon,
  ...CustomerList,
  ...CustomerInfo,
  ...UserCreateAccount,
  ...UserCreateAccountSelectManager,
  ...CustomerInfoChangePassword,
  ...CustomerInfoChangeInfo,
  ...UserGroup
}


// WEBPACK FOOTER //
// ./src/lang/user/kr.js